import { FC, ReactChild, ReactChildren } from 'react'
import { cn } from '@bem-react/classname'

import { Memo } from '@/hoc/Memo'

import { Container } from '@/components/Container'
import { Header } from './components/Header'
import { Footer } from './components/Footer'

import './styles/LayoutApp.scss'
import { Loading } from '@/components/Loading'
import { useAppSelector } from '@/core/store/hooks'
import { loadingSelector } from '@/core/services/Loading/store/loading.selector'
import { useLocation } from 'react-router-dom'

const cnLayout = cn('Layout')

interface LayoutInterface {
  children: ReactChild | ReactChildren
}

export const LayoutApp: FC<LayoutInterface> = Memo(
  ({ children }: LayoutInterface) => {
    const isLoading = useAppSelector(loadingSelector)
    const { pathname } = useLocation()
    return (
      <div className={cnLayout()}>
        <Header />
        {pathname === '/' || pathname === '/cabinet/licenses' ? (
          children
        ) : (
          <Container>{children}</Container>
        )}

        <Footer />

        <Loading visible={isLoading} position='fixed' isBackground />
      </div>
    )
  },
)
